import { Star } from 'lucide-react';
import { VARIABLES } from '@app/components/common/constants';

interface VariableCardProps {
  variable: (typeof VARIABLES)[number];
  isSelected: boolean;
  isFavorite: boolean;
  onSelect: () => void;
  onToggleFavorite: () => void;
  disabled: boolean;
}

export function VariableCard({
  variable,
  isSelected,
  isFavorite,
  onSelect,
  onToggleFavorite,
  disabled,
}: VariableCardProps) {
  return (
    <div
      className={`
        relative p-3 rounded-lg border cursor-pointer transition-all duration-200
        ${
          isSelected
            ? 'border-pink-300 bg-pink-50 dark:border-pink-500 dark:bg-pink-900/20'
            : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-sm'}
      `}
      onClick={!disabled ? onSelect : undefined}
    >
      <button
        className={`
          absolute top-2 right-2 p-1 rounded transition-colors
          ${isFavorite ? 'text-pink-500' : 'text-gray-400 hover:text-pink-500'}
        `}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) onToggleFavorite();
        }}
      >
        <Star className={`h-3 w-3 ${isFavorite ? 'fill-current' : ''}`} />
      </button>

      <div className="pr-6">
        <h4 className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1">
          {variable.label.split(' [')[0]}
        </h4>
        <p className="text-xs text-gray-500 dark:text-gray-400 line-clamp-2">
          {variable.description}
        </p>
        <span className="text-xs text-pink-600 dark:text-pink-400 font-mono mt-1 block">
          {variable.displayUnit}
        </span>
      </div>
    </div>
  );
}
